// Parser for Warmane/CavernOfTime raid statistics HTML specifically for
// Trial of the Crusader / Trial of the Grand Crusader (TOC)
// Exports parseTableToc(html) which returns an array of
// { boss, code, value, rawDesc, rawValue }

function cleanHtml(raw) {
  if (!raw) return '';
  let s = raw.replace(/\\+/g, '');
  s = s.replace(/<\s*\/\s*/g, '</');
  s = s.replace(/<\s+/g, '<');
  s = s.replace(/\s+>/g, '>');
  s = s.replace(/\s+/g, ' ');
  return s;
}

function extractRows(html) {
  const rows = [];
  const trRe = /<tr\b[^>]*>([\s\S]*?)<\/tr>/gi;
  let m;
  while ((m = trRe.exec(html)) !== null) rows.push(m[1]);
  return rows;
}

function extractTds(trInner) {
  const tds = [];
  const tdRe = /<td\b[^>]*>([\s\S]*?)<\/td>/gi;
  let m;
  while ((m = tdRe.exec(trInner)) !== null) {
    const inner = m[1].replace(/<[^>]+>/g, '').trim();
    tds.push(inner);
  }
  return tds;
}

export function parseTableToc(html) {
  const cleaned = cleanHtml(html || '');
  const tbodyMatch = cleaned.match(/<tbody[^>]*>([\s\S]*?)<\/tbody>/i);
  const body = tbodyMatch ? tbodyMatch[1] : cleaned;
  const rows = extractRows(body);
  const out = [];
  for (const rowInner of rows) {
    const tds = extractTds(rowInner);
    if (tds.length < 2) continue;
    const desc = (tds[0] || '').trim();
    const valRaw = (tds[1] || '').trim();

    // Determine size and difficulty from the parenthetical suffix
    // Examples:
    //  - Lord Jaraxxus kills (Trial of the Crusader 10 player)
    //  - Lord Jaraxxus kills (Trial of the Grand Crusader 25 player)
    const parenMatch = desc.match(/\(([^)]+)\)\s*$/);
    const inParen = parenMatch ? parenMatch[1] : '';
    const is10 = /(?:\b10\b|10\s*player|10-player)/i.test(inParen) || /\(\s*10\s*player\s*\)$/i.test(desc);
    const is25 = /(?:\b25\b|25\s*player|25-player)/i.test(inParen) || /\(\s*25\s*player\s*\)$/i.test(desc);
    const isHeroic = /grand crusader/i.test(inParen) || /grand crusader/i.test(desc);

    // Strip the trailing parentheses part to get the base label
    let boss = desc.replace(/\s*\([^)]*\)\s*$/,'').trim();

    // Normalize the last line variant: always use the "Crusader" label
    // even if the armory shows "Grand Crusader" on heroic rows
    boss = boss.replace(/Trial of the Grand Crusader/i, 'Trial of the Crusader');

    // Compute a TOC code we can map on later
    let code = null;
    if (is10) code = `TOC 10${isHeroic ? 'HC' : 'NM'}`;
    else if (is25) code = `TOC 25${isHeroic ? 'HC' : 'NM'}`;

    // Parse numeric value when possible; also keep raw string
    let value = null;
    const v = valRaw.replace(/,/g, '').trim();
    if (/^-+$/i.test(v) || v === '') value = null;
    else {
      const n = parseInt(v, 10);
      value = Number.isNaN(n) ? null : n;
    }

    out.push({ boss, code, value, rawDesc: desc, rawValue: valRaw });
  }
  return out;
}

const exported = { parseTableToc };
export default exported;
